import { render } from "./DialogSostituisciContenuto.vue?vue&type=template&id=c4c1da1e"
import script from "./DialogSostituisciContenuto.vue?vue&type=script&lang=js"
export * from "./DialogSostituisciContenuto.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__